import { ActionTree } from "vuex";
import { ICommonState } from "./common-states.store";
import { COMMON_LOOKUP_TYPE, default as StoreTypes, OpenAppointmentPropsModel } from "../types";
import { ApiResponse, INavbar } from "../../models/app-configuration";
import { AuthTransfer, AuthVerified } from "../../models/generic/auth-transfer";
import { LOCALSTORAGE_MAP_OPTIONS, LOCALSTORAGE_MAP_REGIONS, ADD_MANAGER_TO_AGENDA_RESOURCE_CONFIG } from "../../common/constants";
import { IAppointmentPlaceSuggestionParameterModel, IAgendaPrefetchInfoDetail } from "../../models/agenda";
import { IPersonAutoComplete } from "../../models/autocomplete";
import { IGridConfiguration } from "../../models/common/grid-config.model";
import gridTypeConstants from "../../common/grid-type.constants";
import { IRouteTab } from "../../models/common/route-tab.model";
import { SetPrintTemplateModalVisibleParamModel } from "../../models/report/report-print-template.model";
import { QuickViewPropsModel } from "../types";

let horizontalPageTimeoutCleaner: any;
let setPageActiveTimeoutCleaner: any;

const actions = <ActionTree<ICommonState, any>>{
	[StoreTypes.Set.STREAMING]: ({ commit }, isStreaming: boolean) => {
		commit(StoreTypes.Set.STREAMING, isStreaming);
	},
	[StoreTypes.Set.PAGEREADY]: ({ commit }, pageReady: boolean) => {
		commit(StoreTypes.Set.PAGEREADY, pageReady);
	},

	[StoreTypes.Get.PAGEACTIVE]: ({ commit }, navbar: INavbar) => {
		clearTimeout(setPageActiveTimeoutCleaner);
		setPageActiveTimeoutCleaner = setTimeout(() => {
			commit(StoreTypes.Set.PAGEACTIVE, navbar);
		}, 50);
	},

	[StoreTypes.Set.HORIZONTALPAGE]: ({ commit }, isHorizontalPage: boolean) => {
		clearTimeout(horizontalPageTimeoutCleaner);
		horizontalPageTimeoutCleaner = setTimeout(() => {
			if (isHorizontalPage) {
				document.body.className = "horizontal-navigation chrome-browser";
			} else {
				document.body.className = "with-side-menu";
			}
			commit(StoreTypes.Set.HORIZONTALPAGE, isHorizontalPage);
		}, 50);
	},

	[StoreTypes.Set.USERSESSION]: (
		{ commit },
		session: { config: AuthTransfer; userInfo: AuthVerified }
	) => {
		commit(StoreTypes.Set.USERSESSION, session);
	},
	[StoreTypes.Set.ASSIGNVALUE]: ({ }, payload) => {
		payload.destination = Object.assign(payload.value, payload.destination);
	},
	[StoreTypes.Get.MAPOPTIONS]: ({ getters, commit }) => {
		if (getters.mapOptions !== null) {
			return Promise.resolve(
				typeof getters.mapOptions === "string"
					? JSON.parse(getters.mapOptions)
					: getters.mapOptions
			);
		} else
			return getters.service
				.getMapOptions()
				.then(option => {
					localStorage.setItem(
						LOCALSTORAGE_MAP_OPTIONS,
						JSON.stringify(option)
					);
					commit(StoreTypes.Set.MAPOPTIONS, option);
					return Promise.resolve(option);
				})
				.catch(ex => {
					commit(StoreTypes.Set.MAPOPTIONS, null);
					return Promise.reject(ex);
				});
	},
	[StoreTypes.Get.MAPREGIONS]: (
		{ getters, commit },
		typeOfPropertyId?: number
	) => {
		if (getters.mapRegions !== null) {
			return Promise.resolve(
				typeof getters.mapRegions === "string"
					? JSON.parse(getters.mapRegions)
					: getters.mapRegions
			);
		} else
			return getters.service
				.getMapRegions(typeOfPropertyId)
				.then(regions => {
					localStorage.setItem(
						LOCALSTORAGE_MAP_REGIONS,
						JSON.stringify(regions)
					);
					commit(StoreTypes.Set.MAPREGIONS, regions);
					// commit(StoreTypes.Set.TYPE_OF_PROPERTY_ID, typeOfPropertyId);
					return Promise.resolve(regions);
				})
				.catch(ex => {
					commit(StoreTypes.Set.MAPREGIONS, null);
					return Promise.reject(ex);
				});
	},
	[StoreTypes.Get.PLACE_SUGGESTION]: (
		{ getters, commit },
		payload: {
			param: IAppointmentPlaceSuggestionParameterModel;
			default: boolean;
		}
	) => {
		if (
			payload.param.Keyword === getters.oldQuery &&
			payload.default === undefined
		)
			return Promise.resolve(getters.listOfPlaces);
		else
			return getters.service["getPlaceSuggestion"](
				payload.param,
				payload.default
			)
				.then((places: string[]) => {
					commit(StoreTypes.Set.PLACE_SUGGESTION, places);
					commit(StoreTypes.Set.PREV_QUERY, payload.param.Keyword);
					return Promise.resolve(places);
				})
				.catch(result => {
					return Promise.reject(result);
				});
	},
	[StoreTypes.Get.LIST_OF_PEOPLE]: (
		{ getters, commit },
		queryString: string
	) => {
		if (queryString === getters.oldQueryPeople)
			return Promise.resolve(getters.listOfPeople);
		else
			return getters.service["getListOfPeople"](queryString)
				.then((people: IPersonAutoComplete[]) => {
					commit(StoreTypes.Set.LIST_OF_PEOPLE, people);
					commit(StoreTypes.Set.PREV_QUERY_PEOPLE, queryString);
					return Promise.resolve(people);
				})
				.catch(result => {
					console.log(result);
				});
	},
	[StoreTypes.Get.GRID_CONFIGS]: ({ getters, commit }, type: string) => {
		switch (type) {
			case gridTypeConstants.properties:
				if (getters.gridConfigsProperties != null)
					return Promise.resolve(getters.gridConfigsProperties);
				break;
			case gridTypeConstants.demands:
				if (getters.gridConfigsDemands != null)
					return Promise.resolve(getters.gridConfigsDemands);
				break;
			case gridTypeConstants.persons:
				if (getters.gridConfigsPersons != null)
					return Promise.resolve(getters.gridConfigsPersons);
				break;
			case gridTypeConstants.tasks:
				if (getters.gridConfigsTasks != null)
					return Promise.resolve(getters.gridConfigsTasks);
				break;
		}

		return getters.service
			.getGridConfigs(type)
			.then((configs: IGridConfiguration) => {
				switch (type) {
					case gridTypeConstants.properties:
						commit(StoreTypes.Set.GRID_CONFIGS_PROPERTY, configs);
						break;
					case gridTypeConstants.demands:
						commit(StoreTypes.Set.GRID_CONFIGS_DEMAN, configs);
						break;
					case gridTypeConstants.persons:
						commit(StoreTypes.Set.GRID_CONFIGS_PERSON, configs);
						break;
					case gridTypeConstants.tasks:
						commit(StoreTypes.Set.GRID_CONFIGS_TASK, configs);
						break;
				}

				return Promise.resolve(configs);
			})
			.catch(result => {
				console.log(result);
			});
	},
	[StoreTypes.Set.GRID_CONFIGS]: ({ getters, commit }, payload: { type: string, configuration: IGridConfiguration }) => {
		return getters.service
			.setGridConfigs(payload.type, payload.configuration)
			.then((configs) => {
				switch (payload.type) {
					case gridTypeConstants.properties:
						commit(StoreTypes.Set.GRID_CONFIGS_PROPERTY, payload.configuration.Config);
						break;
					case gridTypeConstants.demands:
						commit(StoreTypes.Set.GRID_CONFIGS_DEMAN, payload.configuration.Config);
						break;
					case gridTypeConstants.persons:
						commit(StoreTypes.Set.GRID_CONFIGS_PERSON, payload.configuration.Config);
						break;
					case gridTypeConstants.tasks:
						commit(StoreTypes.Set.GRID_CONFIGS_TASK, payload.configuration.Config);
						break;
				}
				return Promise.resolve(configs);
			})
			.catch(result => {
				console.log(result);
			});
	},
	[COMMON_LOOKUP_TYPE.DELETE_COMMON_VISITED_VIEWS]: ({ state, commit }, payload: { route: IRouteTab, index: number }) => {
		return new Promise(resolve => {
			commit(COMMON_LOOKUP_TYPE.DELETE_COMMON_VISITED_VIEWS, payload);
			resolve({
				visitedViews: [...state.visitedViews]
			})
		})
	},
	[COMMON_LOOKUP_TYPE.GET_CONSULTED_NEXT_PERSON]: ({ getters, commit }, payload: { number: number }) => {
		return getters.service[COMMON_LOOKUP_TYPE.GET_CONSULTED_NEXT_PERSON](payload).then((response: any) => {
			if (response.isSuccess) {
				commit(COMMON_LOOKUP_TYPE.GET_CONSULTED_NEXT_PERSON, (response.data || []));
				return response.data || [];
			}
		});
	},
	[COMMON_LOOKUP_TYPE.GET_GRID_CONFIG_USED_USERS]: ({ getters, commit, state }, payload: string) => {
		if (state.gridConfigsUsedUsers[payload]) return Promise.resolve(state.gridConfigsUsedUsers[payload]);
		return getters.service[COMMON_LOOKUP_TYPE.GET_GRID_CONFIG_USED_USERS](payload)
			.then((response: ApiResponse) => {
				if (response.isSuccess) {
					commit(COMMON_LOOKUP_TYPE.GET_GRID_CONFIG_USED_USERS, {
						key: payload,
						value: response.data
					})
					return response.data;
					// todo : commit to post 
				}
				commit(COMMON_LOOKUP_TYPE.GET_GRID_CONFIG_USED_USERS, {
					key: payload,
					value: []
				})
				return [];
			})
	},
	[COMMON_LOOKUP_TYPE.GLOBAL_SEARCH]: ({ getters, commit }, payload: { text?: string, group?: boolean }) => {
		return getters.service[COMMON_LOOKUP_TYPE.GLOBAL_SEARCH](payload).then((response: ApiResponse) => {
			return response.data;
		});
	},
	[StoreTypes.Set.SEND_MESSAGE_MODAL_VISIBLE]: ({ commit }, payload: SetPrintTemplateModalVisibleParamModel) => {
		commit('setSendMessageModalVisible', payload);
    },
	[StoreTypes.Set.SEND_SMS_MODAL_VISIBLE]: ({ commit }, payload: SetPrintTemplateModalVisibleParamModel) => {
		commit('setSendSMSModalVisible', payload);
    },
    [StoreTypes.Set.LARGE_MAILING_MODAL_VISIBLE]: ({ commit }, payload: SetPrintTemplateModalVisibleParamModel) => {
		commit('setLargeMailingModalVisible', payload);
	},
	setPrintTemplateModalVisible: ({ commit }, payload: SetPrintTemplateModalVisibleParamModel) => {
		commit('setPrintTemplateModalVisible', payload);
	},
	setQuickViewObjectProps: ({ commit }, payload: QuickViewPropsModel) => {
		commit('setQuickViewObjectProps', payload);
  	},
	setNotificationMessage: ({ commit }, payload: any) => { 
		commit('setNotificationMessage', payload);
	},
	[StoreTypes.Set.PERSON_MERGE_DATA_TEMP]: ({ commit }, payload: object) => { 
		commit(StoreTypes.Set.PERSON_MERGE_DATA_TEMP, payload);
    },
	setOpenAppointmentProps: ({ commit }, payload: OpenAppointmentPropsModel) => {
		commit('setOpenAppointmentProps', payload);
    },
    setAgendaPrefetchProperty: ({ getters, commit }, payload: { Id: number, Info}) => {
        return new Promise((resolve) => {
            // handle get property information add set to agenda prefetch info
            return getters.service.getPrefetchPropertyAgenda(payload.Id).then(data => {
                const info: IAgendaPrefetchInfoDetail = {
                    Id: payload.Id,
                    FutureAppointments: (data && data.FutureAppointments) || [],
                    ManagerId: data && data.ManagerId,
                    Info: payload.Info
                }
               
                commit('setAgendaPrefetchInfo', {
                    key: 'propertyInfo',
                    data: info
                })
                commit('setAgendaPrefetchPropertyManager', {
                    configValue: data.AddManagerToAgenda,
                    managerId: data.ManagerId
                })
                return resolve(info);
            }).catch(err => {
                const info: IAgendaPrefetchInfoDetail = {
                    Id: payload.Id,
                    FutureAppointments: [],
                    ManagerId: null,
                    Info: payload.Info
                }

                commit('setAgendaPrefetchInfo', {
                    key: 'propertyInfo',
                    data: info
                })
                commit('setAgendaPrefetchPropertyManager', {
                    configValue: ADD_MANAGER_TO_AGENDA_RESOURCE_CONFIG.DO_NOT_ADD,
                    managerId: null
                })
                return resolve(info);
            })
            
        })
    },
    setAgendaPrefetchPerson: ({getters, commit}, payload: {Id: number, Info}) => {
        return new Promise((resolve) => {
            // handle get person information add set to agenda prefetch info
            return getters.service.getPrefetchPersonAgenda(payload.Id).then(data => {
                const info: IAgendaPrefetchInfoDetail = {
                    Id: payload.Id,
                    FutureAppointments: (data && data.FutureAppointments) || [],
                    ManagerId: data && data.ManagerId,
                    Info: payload.Info,
                    AddManagerToAgenda: data.AddManagerToAgenda
                }

                commit('setAgendaPrefetchInfo', {
                    key: 'personInfo',
                    data: info
                })
                commit('setAgendaPrefetchPersonManager', {
                    configValue: data.AddManagerToAgenda,
                    managerId: data.ManagerId
                })
                return resolve(info);
            }).catch(err => {
                const info: IAgendaPrefetchInfoDetail = {
                    Id: payload.Id,
                    FutureAppointments: [],
                    ManagerId: null,
                    Info: payload.Info
                }

                commit('setAgendaPrefetchInfo', {
                    key: 'personInfo',
                    data: info
                })
                commit('setAgendaPrefetchPersonManager', {
                    configValue: ADD_MANAGER_TO_AGENDA_RESOURCE_CONFIG.DO_NOT_ADD,
                    managerId: null
                })
                return resolve(info);
            })
        })
    },
    setAgendaPrefetchTask: ({ commit }, payload: { Id: number, UserId: number }) => {
        commit('setAgendaPrefetchInfo', { key: 'taskId', data: payload.Id });
        commit('setAgendaPrefetchInfo', { key: 'taskUserId', data: payload.UserId || null });
    },
    resetAgendaPrefetchInfo: ({ commit }, key: string) => {
        commit('resetAgendaPrefetchInfo', key);
    },
    [StoreTypes.Set.WEBAPP_LAYOUT]: ({ commit }, layoutMode: string) => {
        commit(StoreTypes.Set.WEBAPP_LAYOUT, layoutMode);
    },
};

export default actions;
